<template>
  <div class="row">
    <div class="col-md-4 d-flex align-items-center c-charcoal">
      {{ translationText }}
    </div>
    <div class="col-md-8 d-flex align-items-center">
      <textarea
        @input="updateTranslation"
        v-model="localTranslatedText"
        :name="translationKey"
        rows="1"
        class="form-control m-0 w-100"
      ></textarea>
      <div @click="removeSingleTranslation" class="close-icon p-1 pl-2">
        <font-awesome-icon :icon="['far', 'trash-alt']" class="fa-fw" />
      </div>
    </div>
  </div>
</template>
<script>
import { get } from 'lodash';
import { mapState } from 'vuex';
import { REMOVE_SINGLE_TRANSLATION } from '@/core/store/mutation-types';

export default {
  name: 'TranslationInput',
  props: {
    translationText: {
      type: String,
    },
    translationKey: {
      type: String,
    },
  },
  computed: {
    ...mapState('studio', ['currentTranslationsEditLang']),
    fullTransalationKey() {
      return `${this.currentTranslationsEditLang}.${this.translationKey}`;
    },
  },
  data() {
    return {
      localTranslatedText: '',
    };
  },
  methods: {
    updateTranslation(event) {
      this.$emit('input', {
        translationText: event.target.value,
        translationKey: this.translationKey,
      });
    },
    removeSingleTranslation() {
      this.$store.commit(`studio/${REMOVE_SINGLE_TRANSLATION}`, {
        translationKey: this.fullTransalationKey,
      });
      this.localTranslatedText = '';
    },
    updateSavedTranslatedText() {
      this.localTranslatedText = get(
        this.$store.state.studio.translations?.translations,
        this.fullTransalationKey,
        ''
      );
    },
  },
  mounted() {
    this.updateSavedTranslatedText();
    this.unsubscribe = this.$store.subscribe(() => {
      this.updateSavedTranslatedText();
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
};
</script>
<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.close-icon {
  cursor: pointer;
  color: $medium-gray;
  &:hover {
    color: var(--brand-color, $coral);
  }
}
</style>
